export function About() {
  return (
    <section id="about" className="border-line bg-cream-2 border-b">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-24 md:grid-cols-12 md:py-32">
        <div className="md:col-span-4">
          <p className="marketing-label text-clay">About</p>
          <h2 className="font-display mt-4 text-4xl leading-tight md:text-5xl">
            Small by design.
          </h2>
        </div>

        <div className="text-ink space-y-6 text-base leading-[1.75] md:col-span-7 md:col-start-6 md:text-lg">
          <p>
            A2 is a small house, on purpose. We don&apos;t take on more than we can pour
            ourselves into &mdash; which is why our partners get campaigns built by people who
            actually know the product, the audience, and the platform.
          </p>
          <p className="text-clay">
            From creator discovery and outreach to partnership management and reporting &mdash; we
            run influencer campaigns end-to-end so founders can stay focused on building.
          </p>
        </div>
      </div>
    </section>
  );
}
